module.exports = __webpack_public_path__ + "static/mg-1e8713a8820a644552d66ac6e5c447ba.png";